import {
    Button,
    Flex,
    pxToRem,
    ReadMore,
    useAppDisplayModeContext,
} from '@archipro-design/aria';
import { useStyles } from '@archipro-design/aria';
import { CustomInvite } from '@archipro-design/icons';
import type { DesignBoardWithDetailedPinsFragment } from 'generated/graphql';
import * as S from './BoardDescription.style';
import { ToggleBottomMenuButton } from '~/modules/design-board/component/mobile-menu/ToggleBottomMenuButton';
import { useDesignBoardPageState } from '@modules/design-board/component/context';
import BoardActionWithLoginPrompt from '@modules/design-board/component/board-detail/BoardActionWithLoginPrompt';
import { useTracker } from '@archipro-website/tracker';
interface BoardDescriptionProps {
    board: DesignBoardWithDetailedPinsFragment;
}

const BoardDescription = ({ board }: BoardDescriptionProps) => {
    const { css } = useStyles();
    const { mobile } = useAppDisplayModeContext();
    const { dispatch } = useDesignBoardPageState();
    const tracker = useTracker();

    const desktopContent =
        board.Content && board.PinsCount > 0 ? (
            <div className={css(S.FlatDescription)}>{board.Content}</div>
        ) : null;

    return mobile ? (
        <Flex className={css(S.BoardDescriptionWrapper)} column={false}>
            <ReadMore
                content={board.Content}
                maxLines={2}
                readLessText="View Less"
                readMoreText="View More"
                variables={{
                    toggleFontSize: pxToRem(14),
                    elementGap: 0,
                    contentFontSizeInPx: 14,
                    contentLineHeight: 1.3,
                }}
                className={css(S.MoreOrLess)}
            />

            <BoardActionWithLoginPrompt
                action={
                    <Button
                        color="grey"
                        iconBefore={<CustomInvite />}
                        size={24}
                        variables={{
                            buttonPadding: 0,
                            iconPadding: 0,
                            buttonSize24IconXMargin: '0',
                        }}
                        className={css(S.InviteButton)}
                        onClick={() => {
                            dispatch({ type: 'OpenShareBoardModal' });
                            tracker.log('InviteCollaboratorsReveal', {
                                url: new URL(window.location.href),

                                data: {
                                    ElementID:
                                        'designboard_detail_header_inviteCollaboratorsReveal',
                                    Source: 'designBoard, detail',
                                },
                            });
                        }}
                    ></Button>
                }
            />

            <ToggleBottomMenuButton
                className={css(S.MoreButton)}
                bottomMenuData={{ type: 'board' }}
                currentBoardData={board}
            />
        </Flex>
    ) : (
        desktopContent
    );
};

export default BoardDescription;
